export default __webpack_public_path__ + "static/media/hard music.5b9c9f71.png";